/**
 * Returns true when `currentJobIds` contains an id that was not in
 * `previousJobIds` — i.e. a new job appeared and polling should restart from
 * the shortest delay. Order-independent.
 */
const hasNewPendingJob = (
  previousJobIds: string[],
  currentJobIds: string[]
) => {
  const previous = new Set(previousJobIds);
  return currentJobIds.some((id) => !previous.has(id));
};

export default hasNewPendingJob;
